import { render } from "./Manual.vue?vue&type=template&id=35c13716"
import script from "./Manual.vue?vue&type=script&lang=js"
export * from "./Manual.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__